import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogContentText, DialogActions, DialogTitle, Button } from '@material-ui/core';
import moment from 'moment-timezone';

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    minWidth: '500px',
    maxHeight: '80vh'
  }
}));

interface ViewUserDialog {
  dialogOpen?: true | false;
  handleDialog?: any;
  userData: any;
  participantCode?: any;
  // handleDialogSubmit?: any;
}

const ViewTenantUserDialog = (props: ViewUserDialog) => {
  const [open, setOpen] = React.useState<any>(false);
  const classes = useStyles();
  useEffect(() => {
    setOpen(props.dialogOpen);
  }, [props.dialogOpen]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={props.handleDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle id="alert-dialog-title">{'User Information'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div>
              <span>User Name:</span> <span>{props?.userData?.userName}</span>
            </div>
            <div>
              <span>First Name:</span> <span>{props?.userData?.firstName}</span>
            </div>
            <div>
              <span>Last Name:</span> <span>{props?.userData?.lastName}</span>
            </div>
            <div>
              <span>Status:</span> <span>{props?.userData?.status}</span>
            </div>
            <div>
              <span>User Creation Date:</span>{' '}
              <span>{moment(props?.userData?.userCreationDate).format('MM/DD/YYYY hh:mm:ss A')}</span>
            </div>
            {/* Enable last login date and last modified fileds if */}
            <div>
              <span>Last Modified Date:</span>{' '}
              <span>{moment(props?.userData?.userLmd).format('MM/DD/YYYY hh:mm:ss A')}</span>
            </div>
            <div>
              <span>Last Login Date:</span>{' '}
              <span>{moment(props?.userData?.userLastLoginDate).format('MM/DD/YYYY hh:mm:ss A')}</span>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Disagree</Button> */}
          <Button onClick={props.handleDialog} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ViewTenantUserDialog;
